import * as React from 'react';
export const arrowUpDownSvg = React.forwardRef(function arrowUpDownSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M1.926 7.243a.8.8 0 0 1 1.131-.017L6 10.085l2.943-2.859a.8.8 0 0 1 1.114 1.148l-3.5 3.4a.798.798 0 0 1-1.114 0l-3.5-3.4a.8.8 0 0 1-.017-1.131ZM5.443.226a.798.798 0 0 1 1.114 0l3.5 3.4a.8.8 0 0 1-1.114 1.148L6 1.915 3.057 4.774a.8.8 0 1 1-1.114-1.148l3.5-3.4Z',
    }),
  );
});
arrowUpDownSvg.defaultProps = {
  width: '12',
  height: '12',
  viewBox: '0 0 12 12',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var arrowUpDown = {
  category: 'icon',
  colorable: true,
  name: 'arrowUpDown',
  svg: arrowUpDownSvg,
};
